import { useState } from "react";
import "../../theme/globals.scss";
import "../../App.scss";
import { Container } from "@chakra-ui/react";
import { WagmiProvider } from "wagmi";
import { QueryClientProvider } from "@tanstack/react-query";
import { wagmiAdapter, queryClient } from "../../services/walletConnect.service";

import Cookies from "../../components/Cookies/Cookies";
import Footer from "./components/Footer/Footer.component";
import Header from "./components/Header/Header.component";
import styles from "./UnavailablePage.module.scss";
import Headline from "../../components/Headline/Headline.component";

function UnavailablePage() {
  const [isCookiesOpen, setIsCookiesOpen] = useState(true);

  const consentToAllCookies = () => {
    setIsCookiesOpen(false);
  };

  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {isCookiesOpen && <Cookies consentToAllCookies={consentToAllCookies} />}
        <div>
          <Header />
          <Container maxW="70rem">
            <h1 id="title" className="page-title">
              Distribution Simulator
            </h1>

            <section className={styles.section}>
              <div className={styles.content}>
                <Headline title="Distribution simulator is no longer available" />
                <p>
                  The good news is that you can visit the Flare Advisor to get all information regarding earning
                  opportunities on Flare, such as staking, delegating, and receiving drops.
                </p>
                <p>Visit the site to continue your exploration of the opportunities within the Flare ecosystem.</p>

                <a href="https://flare.space/dapp/flare-advisor" className={styles.button} target="_self" rel="noopener noreferrer">
                  Let&apos;s go
                </a>
              </div>
            </section>
          </Container>

          <Footer />
        </div>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default UnavailablePage;
